<app-pop-up [title]="'ATENÇÃO FARMACÊUTICA'" [size]="'auto'" (save)="save()" (close)="close()">
  <div class="popUp-body gap-10">
    <app-title [title]="'MEDICAMENTO'"></app-title>
    <app-search-medications-in-use (medication)="getSelectedMedication($event)"
      [medShow]="medicamento"></app-search-medications-in-use>
    <div class="row align-start gap-20">
      <div class="column">
        <app-title [title]="'Via'"></app-title>
        <div class="row gap-20">
          <div class="radio-item">
            <input type="radio" id="via1" name="via" value="EV" label="EV" [formControl]="viaCtrl">
            <label class="m-r-5" for="via1">{{ 'EV' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via2" name="via" value="IL" label="IL" [formControl]="viaCtrl">
            <label class="m-r-5" for="via2">{{ 'IL' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via3" name="via" value="IM" label="IM" [formControl]="viaCtrl">
            <label class="m-r-5" for="via3">{{ 'IM' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via4" name="via" value="SC" label="SC" [formControl]="viaCtrl">
            <label class="m-r-5" for="via4">{{ 'SC' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via5" name="via" value="SL" label="SL" [formControl]="viaCtrl">
            <label class="m-r-5" for="via5">{{ 'SL' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via6" name="via" value="VO" label="VO" [formControl]="viaCtrl">
            <label class="m-r-5" for="via6">{{ 'VO' }}</label>
          </div>
          <div class="radio-item">
            <input type="radio" id="via7" name="via" value="TÓPICO" label="TÓPICO" [formControl]="viaCtrl">
            <label class="m-r-5" for="via7">{{ 'TÓPICO' }}</label>
          </div>
        </div>
      </div>
      <div class="column">
        <app-title [title]="'OBSERVAÇÃO / USO'"></app-title>
        <div class="row align-center gap-20">
          <app-text-area [height]="'69px'" [width]="'100%'" class="input-text-area scrollbar" style="margin-right: 18px"
            id="style-1" [control]="observationsCtrl"></app-text-area>
          <app-button [text]="button" (buttonEvent)="includeMedication()"
            [disabled]="!observationsCtrl.value || !viaCtrl.value" type="primary"></app-button>
        </div>
      </div>
    </div>
    <div class="table-scroll-wrapper scrollbar" id="style-1">
      <table class="table-medications">
        <colgroup>
          <col class="col-medication">
          <col class="col-via">
          <col class="col-obs">
          <col class="col-action">
          <col class="col-action">
        </colgroup>

        <thead>
          <tr>
            <th class="th-medication">MEDICAMENTOS EM USO</th>
            <th class="th-via">VIA</th>
            <th class="th-obs">OBSERVAÇÃO/USO</th>
            <th class="th-action"></th>
            <th class="th-action"></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of finalTable" class="table-row-even">
            <td class="no-wrap-lines" [matTooltip]="item.medicamento" matTooltipPosition="below">
              {{ item.medicamento }}
            </td>

            <td>{{ item.via }}</td>

            <td class="col-obs-content">
              {{ item.observacao }}
            </td>

            <td class="col-action" style="padding: 0px;">
              <div *ngIf="item !== ''">
                <button class="btn" style="width: 10px;"
                  (click)="editSelectedMedication(item)"><mat-icon>edit</mat-icon></button>
              </div>
            </td>

            <td class="col-action" style="padding: 0px;">
              <div *ngIf="item !== ''" class="add-edit-button">
                <button class="btn remove" (click)="deleteMedication(item)"><mat-icon>cancel</mat-icon></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</app-pop-up>